export const data = [
    {
        title:"Websites",
        desc:"Easily create, customize, and promote a stunning website"
    },{
        title:"Online Stores",
        desc:" Create online store—reach customers and drive sales with built-in marketing tools."

    },{
        title:"APPOINTMENT-SCHEDULING",
        desc:"Free appointment scheduling is for one-on-one appointment booking and single services"

    },
    {
        title:"Domains",
        desc:"Get a domain your ideas can call home"
    }
]